import React from 'react';
import { AppUI } from '@seedlang/state';

export const ComponentForDefaultOrWhitelabelSite = (ComponentForDefaultSite, ComponentForWhitelabelSite) => (
  props => (
    AppUI.siteIsDefault ? <ComponentForDefaultSite {...props} /> : <ComponentForWhitelabelSite {...props} />
  )
);
